<template>
  <section class="content">
    <!-- 門市列表 (圖片庫 or 別名/描述/警語) -->
    <div class="row center-block">
      <div
        v-if="getRoleType === 99"
        class="col-xs-12 p-x-0 m-b-10 flex align-center"
      >
        <router-link :to="{
          name: goBackInfo.name,
          params: goBackInfo.params,
          query: goBackInfo.query
        }">
          <div class="btn btn-default m-r-5 flex">
            <span>返回</span>
            <span v-text="goBackInfo.title" />
            <span v-text="goBackInfo.subtitle" />
          </div>
        </router-link>
        <div class="flex grey darken-1">
          <div
            v-if="brand.name || store.brand_name"
            class="m-r-5"
            v-text="brand.name ? brand.name : store.brand_name ? store.brand_name : ''"
          />
          <div
            v-if="store.name"
            class="m-r-5"
            v-text="'/'"
          />
          <div
            v-if="store.name"
            v-text="store.name"
          />
        </div>
      </div>
      <div class="col-md-12">
        <div class="box">
          <div class="box-body">
            <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
              <div class="row">
                <div class="col-sm-6 text-left">
                  <h5><span class="text-red">＊</span> 可編輯門市{{ $route.name.includes('ProductImage') ? '圖示' : '別名/描述/警語'}} </h5>
                  <h5><span class="text-red">＊</span> 可複製此分店所有設定至其他店家 </h5>
                </div>
                <div class="col-sm-6 text-right">
                  <div class="form-group">
                    <select class="form-control h-38" v-model="searchSelect">
                      <option value="1">名稱</option>
                    </select>
                  </div>
                  <div class="form-group search-bar">
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="searchInput">
                      <span class="input-group-addon c-pointer" @click="searchStore()"><i class="fa fa-search"></i></span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                    <thead>
                      <tr role="row">
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">門市</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">名稱 (ID)</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">縮寫</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="th-fat" v-if="!history">地址</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" v-if="getRoleType !== 50"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="even" role="row" v-for="(store, index) in storeList">
                        <!-- column 0 -->
                        <td class="sorting_1">
                          {{index + 1}}
                        </td>
                        <!-- column 1 -->
                        <td>
                          <a target="_blank" :href="webDomain + 'menu/' + store.id">
                            <img class="img-brand-table" :src="store.image">
                          </a>
                        </td>
                        <!-- column 2 -->
                        <td>
                          <span v-if="$route.name == 'storeHistoryTable'">{{store.name}} ({{store.id}})</span>
                          <router-link v-if="$route.name != 'storeHistoryTable'" :to="{path: '/storeInfo/' + $route.params.brand_id + '/' + store.id}">{{store.name}} ({{store.id}})</router-link>
                        </td>
                        <!-- column 3 -->
                        <td>{{store.name_short}}</td>
                        <!-- column 4 -->
                        <td v-if="!history">
                          <small>
                            <span v-for="deliveryTeyp in getPickupType" v-if="getDTypeInfo(store.delivery_info, deliveryTeyp) && getDTypeInfo(store.delivery_info, deliveryTeyp).is_support">
                              <i v-if="getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 1" class="fa fa-hand-paper-o" aria-hidden="true"></i>
                              <i v-if="getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 2" class="fa fa-inbox" aria-hidden="true"></i>
                              <i v-if="getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 3" class="fa fa-motorcycle" aria-hidden="true"></i>
                              <i v-if="getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 4" class="fa fa-shopping-bag" aria-hidden="true"></i>
                              <i v-if="getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 5" class="fa fa-glass" aria-hidden="true"></i>
                              <i v-if="getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 21" class="fa fa-qrcode" aria-hidden="true"></i>
                              &nbsp;
                            </span>
                            {{store.address}}
                          </small>
                        </td>
                        <!-- column last-->
                        <td class="flex">
                          <router-link :to="{ path: $route.path + '/' + store.id }">
                            <button class="btn btn-default"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                          </router-link>
                          <!-- 非門市權限 或 多門市權限可使用複製 -->
                          <button v-if="getRoleType !== 10 || getStores.length > 1" @click="copyStore(store.id)" class="btn btn-default m-l-5">複製此分店所有設定至其他店家</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <paginate :pageAmount="pageAmount" :total="total" :isActive="isActive"
                          :groupAmount="groupAmount" :clickPage="clickPage" ref="brandPaginate"
                >
                </paginate>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import $ from 'jquery'
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import { mapActions, mapGetters } from 'vuex'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default {
  name: 'StoreMenuTable',
  data () {
    return {
      name: '迷客夏',
      tableIndex: 1,
      groupAmount: 10,
      total: 1,
      count: 10,
      history: false,
      storeList: [],
      searchSelect: 1,
      searchInput: '',
      statusSelect: 99,
      trTypeSelect: 999,
      orderStatusSelect: 99,
      isSearchSelect: 99,
      searchQuery: {} // 搜尋條件
    }
  },
  extends: NdExtendHandleMenu,
  mounted () {
    this.$nextTick(() => {
      $('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      })
    })
    this.getExtendHandleMenuInfo()
  },
  methods: {
    ...mapActions(['setStoreId', 'setStores']),
    getDTypeInfo (dInfo, dIndex) {
      return dInfo.find(function (obj) { return obj.delivery_type === dIndex })
    },
    isActive (index) {
      if (Number(this.tableIndex) === index) return true
      else return false
    },
    getStoreList () {
      let data = {
        page: this.tableIndex,
        size: this.count,
        searchSelect: parseInt(this.searchSelect, 10),
        inputVal: this.searchInput.trim()
      }
      let url = '/brand/' + this.$route.params.brand_id + '/storeList?size=' + data.size
      let queryValue = {}
      if (data.searchSelect === 1 && data.inputVal) {
        if (this.$route.query.name !== data.inputVal) this.tableIndex = 1
        queryValue = {...queryValue, ...{name: data.inputVal}}
        url = url + '&name=' + data.inputVal
      }
      if (parseInt(this.statusSelect, 10) !== 99) {
        if (this.$route.query.status !== this.statusSelect) this.tableIndex = 1
        queryValue = {...queryValue, ...{status: this.statusSelect}}
        url = url + '&status=' + this.statusSelect
      }
      if (parseInt(this.orderStatusSelect, 10) !== 99) {
        if (this.$route.query.is_search !== this.isSearchSelect) this.tableIndex = 1
        queryValue = {...queryValue, ...{order_status: this.orderStatusSelect}}
        url = url + '&order_status=' + this.orderStatusSelect
      }
      if (parseInt(this.trTypeSelect, 10) !== 999) {
        if (this.$route.query.is_search !== this.isSearchSelect) this.tableIndex = 1
        queryValue = {...queryValue, ...{trade_type: this.trTypeSelect}}
        url = url + '&trade_type=' + this.trTypeSelect
      }
      if (parseInt(this.isSearchSelect, 10) !== 99) {
        if (this.$route.query.is_search !== this.isSearchSelect) this.tableIndex = 1
        queryValue = {...queryValue, ...{is_search: this.isSearchSelect}}
        url = url + '&is_search=' + this.isSearchSelect
      }
      if (this.tableIndex) {
        queryValue = {...queryValue, ...{page: this.tableIndex}}
        url = url + '&page=' + this.tableIndex
      }
      this.searchQuery = queryValue
      this.$router.replace({ query: queryValue })
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.storeList = response.data.list
          if (response.data.list.length) {
            this.setStoreId(response.data.list[0].id)
            this.setStores(response.data.list)
          }
          this.total = response.data.list_total
        }
      })
    },
    clickPage (index) {
      this.tableIndex = index
      this.getStoreList()
    },
    searchStore () {
      this.tableIndex = 1
      this.getStoreList()
    },
    copyStore (id) {
      const url = this.$route.path.replace('storeTable', 'copy') + '/' + id
      this.$router.push({ path: url })
    }
  },
  created () {
    const path = this.$route.name
    if (path === 'storeHistoryTable') this.history = true
    if (this.$route.query.page) this.tableIndex = this.$route.query.page
    if (this.$route.query.name) this.searchInput = this.$route.query.name
    if (this.$route.query.status) this.statusSelect = this.$route.query.status
    if (this.$route.query.order_status) this.orderStatusSelect = this.$route.query.order_status
    if (this.$route.query.is_search) this.isSearchSelect = this.$route.query.is_search
    if (this.$route.query.trade_type) this.trTypeSelect = this.$route.query.trade_type
    this.getStoreList()
  },
  computed: {
    ...mapGetters(['getRoleType', 'getPickupType', 'getStores', 'getBrands']),
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    },
    webDomain () {
      return this.$config.web
    }
  },
  watch: {
    statusSelect () {
      this.searchStore()
    },
    orderStatusSelect () {
      this.searchStore()
    },
    isSearchSelect () {
      this.searchStore()
    },
    trTypeSelect () {
      this.searchStore()
    }
  }
}
</script>



// WEBPACK FOOTER //
// store-menu-table.vue?31b26657